import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Group,
  ThemeIcon,
  UnstyledButton,
  Text,
  Stack,
  Container,
} from '@mantine/core';
import {
  IconHome,
  IconTicket,
  IconClipboardText,
  IconUser,
  IconTruck,
} from '@tabler/icons-react';
import styles from './BottomNav.module.css';

interface NavItem {
  icon: typeof IconHome;
  label: string;
  path: string;
  color: string;
}

const NAV_ITEMS: NavItem[] = [
  { icon: IconHome, label: 'Dashboard', path: '/', color: 'gray' },
  { icon: IconTicket, label: 'Tickets', path: '/tickets', color: 'orange' },
  { icon: IconUser, label: 'Meine', path: '/tickets?tab=mine', color: 'orange' },
  { icon: IconClipboardText, label: 'Service', path: '/service-report', color: 'orange' },
  { icon: IconTruck, label: 'Delivery', path: '/delivery-report', color: 'cyan' },
];

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const isItemActive = (itemPath: string) => {
    const currentPath = location.pathname;
    const currentTab = new URLSearchParams(location.search).get('tab') ?? 'mine';
    if (itemPath === '/tickets?tab=mine') {
      return currentPath === '/tickets' && currentTab === 'mine';
    }
    if (itemPath === '/tickets') {
      return (
        currentPath.startsWith('/tickets') &&
        !(currentPath === '/tickets' && currentTab === 'mine')
      );
    }
    if (currentPath === itemPath) return true;
    return currentPath.startsWith(itemPath + '/');
  };

  return (
    <Box className={styles.bottomNav}>
      <Container size="100%" p={0} m={0}>
        <Group
          gap={0}
          grow
          justify="space-around"
          h="100%"
        >
          {NAV_ITEMS.map((item) => {
            const isActive = isItemActive(item.path);
            return (
              <UnstyledButton
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`${styles.navItem} ${isActive ? styles.navItemActive : ''}`}
                aria-label={item.label}
              >
                <Stack gap={2} align="center">
                  <ThemeIcon
                    size="md"
                    variant={isActive ? 'filled' : 'light'}
                    color={isActive ? item.color : 'gray'}
                    radius="sm"
                  >
                    <item.icon size={16} />
                  </ThemeIcon>
                  <Text size="xs" c={isActive ? item.color : 'dimmed'} fw={isActive ? 600 : 400} lh={1}>
                    {item.label}
                  </Text>
                </Stack>
              </UnstyledButton>
            );
          })}
        </Group>
      </Container>
    </Box>
  );
}
